import { Box, IconButton } from "@mui/material";
import { useMemo, useState } from "react";
import SettingsIcon from '@mui/icons-material/Settings';
import { sanitizeHtml } from "../util/sanitise-html";

export interface RenderHtmlProps {
    html?: string;
}

export const RenderHtml = ({ html }: RenderHtmlProps) => {


    const __html = useMemo(() => {
        if (!html) {
            return null
        }
        const h = sanitizeHtml(html);
        const h2 = h.replace("<a ", '<a target="_blank" ')
        return h2;

    }, [html])

    if (!__html) {
        return null;
    }

    return <div dangerouslySetInnerHTML={{ __html }} />

}